export default __webpack_public_path__ + "4c377d213ed66a0033809b0fbcab8b3d.jpg";